import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';

export const Wrapper = styled.section`
  padding: clamp(80px, 8vw, 140px) clamp(20px, 5vw, 96px);
  border-top: 1px solid ${colors.borderSubtle};
  background: radial-gradient(
    90% 130% at 50% 0%,
    rgba(255, 140, 85, 0.1) 0%,
    ${colors.background} 65%
  );
`;

export const Inner = styled.div`
  max-width: 820px;
  margin: 0 auto;
  text-align: center;
`;

export const Heading = styled.h2`
  font-family: ${typography.displayFontFamily};
  font-weight: 800;
  font-size: clamp(32px, 4.4vw, 54px);
  line-height: 1.08;
  letter-spacing: -0.02em;
  margin: 0;
  text-wrap: pretty;
  color: ${colors.textPrimary};
`;

export const Lead = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: ${colors.textSecondary};
  margin: 20px auto 34px;
  max-width: 620px;
`;

export const Note = styled.p`
  margin: 20px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.textFaintest};
`;
